import script from "./JigsawToolbarItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./JigsawToolbarItem.vue?vue&type=script&lang=ts&setup=true"

import "./JigsawToolbarItem.vue?vue&type=style&index=0&id=35b423dc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b423dc"]])

export default __exports__